export enum OnboardingAcknowledgement {
  TRACKING_INSTALLED = 'trackingInstalled',
  SHOPIFY_DATA_SHARING_DISABLED = 'shopifyDataSharingDisabled',
  KLAVIYO_FLOWS_CONFIGURED = 'klaviyoFlowsConfigured',
}
